/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unreachable */
import { useEffect, useState } from 'react';
import { Pagination, Select } from 'antd';
import { apiLaunchPad } from '../../../api/apiLaunchPad';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { formatDateSchedule, } from "../utilsIDO";
import { useNavigate } from 'react-router-dom';
import { useAccount } from 'wagmi';


const Item = ({ item }: any) => {

    const navigate = useNavigate();
    function goToDetail(slug: any): void {
        navigate(`/launchpads/${slug}`);
    }

    return (
        <>
            <tr className='row-item' onClick={() => goToDetail(item?.slug)}>
                <td data-label="Project Name">
                    <div className="box-avt">
                        <div className="avt">
                            <img src={item?.avatar} alt="" />
                        </div>
                        <div className="name-td">
                            {item?.title} <span>{item?.token?.symbol}</span>
                        </div>
                    </div>
                </td>
                <td data-label="Type">
                    <div className="token-sale-name">
                        {item?.campaign_type}
                    </div>
                </td>
                <td data-label="Total Raise">
                    {new Intl.NumberFormat("ja-JP", { maximumFractionDigits: 4 }).format(item?.total_raise)} {item?.currency.symbol}
                </td>
                <td data-label="ATH ROI">
                    <div className="ath-price">
                        {item?.ath_roi  ? `${item?.ath_roi}x`: "--"}
                    </div>
                </td>
                <td data-label="Ended In">
                    <div className="date-ido">
                        {formatDateSchedule(Math.floor((new Date(item?.end_time)).getTime() / 1000))}
                    </div>
                </td>
                <td data-label="Network">
                    <div className="logo-chain">
                        <img src={(item?.token?.chain?.logo)} alt="" />
                        {item?.token?.chain?.name}
                    </div>
                </td>
            </tr>
        </>
    )
}

const CompleteIdo = () => {
    const { address }: any = useAccount();

    const [loading, setLoading] = useState(false)
    const [dataListPool, setDataListPool] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    const [keySearch, setKeySearch] = useState("")
    const [valueSort, setValueSort] = useState('0')
    const [param, setParam] = useState(
        {
            page: 1,
            limit: 5,
        }
    );

    const useDebounce = (value: string, delay: number) => {
        const [debouncedValue, setDebouncedValue] = useState(value);
        useEffect(() => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);
            return () => {
                clearTimeout(handler);
            };
        }, [value, delay]);

        return debouncedValue;
    };

    const handleSearch = (e: any) => {
        setKeySearch(e.target.value)
        setParam({
            ...param,
            page: 1
        });
    };

    const debouncedKeySearch = useDebounce(keySearch, 1000);

    const GetListPoolEnd = async () => {
        setLoading(true)
        try {
            let res = await apiLaunchPad.getPoolEnd(param?.page, param?.limit, keySearch);
            if (res.data.code === 200) {
                setDataListPool(res.data.data);
                setTotalCount(res.data.total)
                setTimeout(() => {
                    setLoading(false)
                }, 1000);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    const GetListPoolJoined = async () => {
        setLoading(true)
        try {
            let res = await apiLaunchPad.getPoolJoinedNew(address, param?.page, param?.limit, keySearch);
            if (res.data.code === 200) {
                setDataListPool(res.data.data);
                setTotalCount(res.data.total)
                setTimeout(() => {
                    setLoading(false)
                }, 1000);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    const GetListPoolClaimable = async () => {
        setLoading(true)
        try {
            let res = await apiLaunchPad.getPoolClaimable(address, param?.page, param?.limit, keySearch);
            if (res.data.code === 200) {
                setDataListPool(res.data.data);
                setTotalCount(res.data.total)
                setTimeout(() => {
                    setLoading(false)
                }, 1000);
            }
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    useEffect(() => {
        if (valueSort === '1') {
            GetListPoolJoined()
        } else if (valueSort === '0') {
            GetListPoolEnd()
        } else if (valueSort === '2') {
            GetListPoolClaimable()
        }

    }, [param, valueSort, address, debouncedKeySearch]);

    const handleChange = (value: string) => {
        setValueSort(value)
        setParam({
            ...param,
            page: 1
        });
    };

    const onChange_Pagi = (pageNumber: any) => {
        setParam({
            ...param,
            page: pageNumber
        });
    };


    return (
        <>
            <div className="main-page-complete">
                <div className="container">
                    <div className="wrap-complete">
                        <div className="main-title main-title-desk">
                            <img src="/images/title-end.png" alt="" />
                        </div>
                        <div className="main-title main-title-mo">
                            <img src="/images/title-end-mo.svg" alt="" />
                        </div>
                        <div className="filter-page filter-page-new">
                            <div className="search-input">
                                <input type="text" onChange={handleSearch} placeholder="Search by project name, token symbol" className="f-search" />
                                <div className="icon">
                                    <img src="/images/icon-search.png" alt="" />
                                </div>
                            </div>
                            <div className="select-sort select-sort-new">
                                {/* <div className="txt">
                                    Joined Projects
                                </div>
                                <label className="toggle-switch" >
                                    <input onClick={handleClickJoined} type="checkbox" />
                                    <div className="toggle-switch-background">
                                        <div className="toggle-switch-handle" />
                                    </div>
                                </label> */}
                                <div className="txt">
                                    Sort by:
                                </div>
                                <Select
                                    defaultValue="All"
                                    style={{ width: 120 }}
                                    onChange={handleChange}
                                    options={[
                                        { value: '0', label: 'All' },
                                        { value: '1', label: 'Joined' },
                                        { value: '2', label: 'Claimable' },
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="wrap-table">
                            {dataListPool?.length === 0 ? (
                                <>
                                    {!keySearch === true && valueSort === '0' ? (
                                        <>
                                            <div className="empty-data-complete">
                                                <div className="empty-data">
                                                    <div className='empty-end'>
                                                        <img style={{ width: '90px', height: '80px' }} src="/images/empty-end.png" alt="" />
                                                        {address ? (
                                                            <p>More details will be updated soon</p>
                                                        ) : (
                                                            <p>Connect your wallet to view details</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="empty-data-complete">
                                                <div className="empty-data">
                                                    <div className='empty-end'>
                                                        <img style={{ width: '111px', height: '140px' }} src="/images/nodata.png" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                </>

                            ) : (
                                <>
                                    <table className="main-table" cellSpacing={0}>
                                        <tr>
                                            <th>
                                                Project Name
                                            </th>
                                            <th>
                                                Type
                                            </th>
                                            <th>
                                                Total Raise
                                            </th>
                                            <th>
                                                ATH ROI
                                            </th>
                                            <th>
                                                Ended In
                                            </th>
                                            <th>
                                                Network
                                            </th>
                                        </tr>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={6}>
                                                    <div className="spin-loading res">
                                                        <Spin className="w-100" size="large" indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} />
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                {dataListPool.map((item: any, index: number) => (
                                                    <Item key={index} item={item} index={index} />
                                                ))}
                                            </>
                                        )}
                                    </table>
                                </>
                            )}

                            {Number(totalCount) > Number(param?.limit) && (
                                <Pagination
                                    current={param.page}
                                    defaultCurrent={1}
                                    total={totalCount}
                                    pageSize={param.limit}
                                    onChange={onChange_Pagi}
                                    showSizeChanger={false}
                                    style={{ marginTop: '15px' }}
                                    className="pagiation-custom mt-15"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default CompleteIdo